<template>
<div>
  <hr class="border-t-top border-t-gray-300 absolute left-0 w-full md:w-[80vw] " aria-hidden="true">
  <section id="warnings" class="py-[2rem] px-6 md:py-[4rem] md:pr-[2.14rem] md:pl-0 lg:scroll-mt-35 scroll-mt-55">
    <Heading :level="4" color="text-ash-200 mr-[-2.142857rem] pb-[1.071428rem]">
      Warnings
    </Heading>
    
    <hr class="border-t border-gray-300" aria-hidden="true">
    <div class="block mt-[1.5rem] pr-[2.14285rem]"> 
      <div :class="{
          'relative after:absolute after:bottom-0 after:left-0 after:h-full after:w-full after:content-[] after:bg-[linear-gradient(to_top,_white_20%,_transparent_80%)] overflow-hidden is-collapsed':
            !expanded && isDisplayShowButton,
          'h-[17.857142857rem]': !expanded && isDisplayShowButton,
          'mb-[1rem]': expanded
        }">
        <div id="warning-content" class="content font-normal text-ash-100 text-[1rem] leading-[1.5] pdp-description" ref="warningDescription">
          <slot name="description">
              <div v-html="description"></div>
            </slot>
        </div>
      </div>
      <div v-if="isDisplayShowButton" class="flex justify-center showmore" :class="{ 'relative -top-[0.714rem]': !expanded, 'relative -top-0': expanded }">
        <Button
          class="button is-large show-more-less text-ash-500"
          @click="toggle"
          :aria-expanded="expanded"
          aria-controls="warning-content"
          variant="secondary"
          theme="LIGHT"
          size="sm"
          id="warning-button"
          :aria-label="expanded ? 'Show less content' : 'Show more content'"
          :title="expanded ? 'Show less content' : 'Show more content'"
        >
          {{ expanded ? 'Show Less' : 'Show More' }}
        </Button>
      </div>
    </div>
  </section>
  <hr class="border-t-top border-t-gray-300 absolute left-0 w-full md:w-[80vw]" aria-hidden="true">
</div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import Heading from "../atom/heading.vue";
import Button from "../atom/button.vue";
import { useStickyTabs } from "~/composables/useNavSticky";

const props = defineProps({
  description: {
    type: String,
    default: "",
  }
});
const route = useRoute()
const id = ref(String(route?.params?.id ?? ""));
const { expandedSections } = useStickyTabs()
const expanded = ref(false);

const warningDescription = ref<HTMLElement | null>(null)
const sectionHeight = ref(0);
const initialHeightSection = ref(250)
const toggle = async() => {
  expanded.value = !expanded.value
  if (!expanded.value) {
    expandedSections.value['warnings'] = false
  }
}

watch(
  () => expandedSections.value.warnings,
  (value) => {
    if (value) {
      expanded.value = true
    }
  },
  {
    immediate: true
  }
)

onMounted(() => {
  requestAnimationFrame(() => { 
    if(warningDescription.value) {
      sectionHeight.value = warningDescription.value.offsetHeight
    }
  });
});

const isDisplayShowButton = computed(()=>{
  return initialHeightSection.value < sectionHeight.value 
})

</script>
